import { render, staticRenderFns } from "./Standby.vue?vue&type=template&id=1c553faf"
import script from "./Standby.vue?vue&type=script&lang=js"
export * from "./Standby.vue?vue&type=script&lang=js"
import style0 from "./Standby.vue?vue&type=style&index=0&id=1c553faf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports